export default (context = {}) =>
  fieldLibrary = {
    fieldGroups: {
      bulk: {
        _requiredFields: []
        # venue:
        #   name: 'Venue Settings'
        #   description: ''
        #   fieldKeys: ['venue_type', 'venue_setting', 'storage_facilities_available']
      }
      advancedSettings: {
        _requiredFields: []
        # venue:
        #   name: 'Venue Settings'
        #   description: ''
        #   fieldKeys: ['venue_description', 'onsite_permissions', 'occupancy_count', 'storage_capacity']
      }
    },
    fields: {
      contact_name: {
        name: 'Shipping Contact Name'
        component: 'text'
        inputProps: {
          placeholder: 'Name of contact'
        }
        options: {
          instructions: 'Enter a recognizable name'
        }
      }
      contact_phone: {
        name: 'Shipping Contact Phone'
        component: 'text'
        inputProps: {
          placeholder: '(555) 555-5555'
        }
        options: {
          instructions: 'Enter a phone number'
        }
      }
      attention_to: {
        name: 'Attention To'
        component: 'text'
        inputProps: {
          placeholder: 'Shipping label: attention to'
        }
        options: {
          instructions: 'Enter the name to send shippiments to'
        }
      }
      accepts_pallets: {
        name: 'Pallets ok?'
        component: 'radio-button'
        inputProps: {
          options: [
            { value: true, label: 'Yes' }
            { value: false, label: 'No' }
          ]
        }
        options: {
          instructions: 'Can this location accept pallets?'
        }
      }
      max_pallet_count: {
        name: 'Max Number of Pallets'
        component: 'number'
        inputProps: {
          placeholder: '10'
        }
        options: {
          instructions: 'How many pallets are you able to receive and store at a time?'
          why: 'Standard pallet measures: 48in Length x 40in Width x 48in Height'
          tips: [
            'Some sponsors may evaluate storage capacity to understand if they can sponsor multiple events and ship all promotional items in a single shipment to save on shipping costs.'
          ]
        }
      }
      loading_dock_available: {
        name: 'Loading Dock Available'
        component: 'radio-button'
        inputProps: {
          options: [
            { value: true, label: 'Yes' }
            { value: false, label: 'No' }
          ]
        }
        options: {
          instructions: 'Is there a loading dock available?'
        }
      }
      truck_requires_lift_gate: {
        name: 'Truck Requires Lift Gate and Pallet Jack'
        component: 'radio-button'
        inputProps: {
          options: [
            { value: true, label: 'Yes' }
            { value: false, label: 'No' }
          ]
        }
        options: {
          instructions: 'Does the truck require a lift gate and pallet jack?'
        }
      }
      special_delivery_instructions: {
        name: 'Special Delivery Instructions'
        component: 'textarea'
        options: {
          instructions: 'Provide any special instructions for delivery'
        }
      }
      property_type: {
        name: 'Property Type'
        component: 'select'
        inputProps: {
          options: [
            { value: 'warehouse', label: 'Warehouse' }
            { value: 'business', label: 'Business' }
            { value: 'residential', label: 'Residential' }
            { value: 'other', label: 'Other' }
          ]
        }
        options: {
          instructions: 'Select the type of property'
        }
      }
      other_property_type: {
        name: 'Other Property Type'
        component: 'text'
        inputProps: {
          placeholder: 'Other property type'
        }
        options: {
          instructions: 'Enter the type of property'
        }
      }
      address: {
        name: 'Address'
        component: 'search-address'
        options: {
          instructions: 'Enter the shipping address for the location'
        }
      }
      street_2: {
        name: 'Address 2'
        component: 'text'
        options: {
          instructions: 'Building #, Suite #, etc.'
        }
      }
      delivery_window: {
        name: 'Delivery Window'
        component: 'shipping-delivery-window'
        options: {
          instructions: 'Set the number of days a shippiment can arrive before an event (earliest to latest)'
        }
      }
      delivery_timeframe: {
        name: 'Delivery Times'
        component: 'shipping-delivery-timeframe'
        options: {
          instructions: 'Enter the hours when a shippiment can be received'
        }
      }
    }
  }

  library = JSON.parse(JSON.stringify(fieldLibrary))

  for key, field of library.fields
    field.inputProps ||= context.inputProps?[key] || {}
    field.inputProps?.options ||= context.options?[key]
    field.options.required ||= key in (context._requiredFields || [])

  library
